import React, { Component } from "react";
import { Link,  } from "react-router-dom";
import { next } from "../images";

class QuickStart extends Component {
	componentDidMount() {
		let offsetTop  = this.quickStartInstance.getBoundingClientRect().top;
		// window.scrollTo(0,offsetTop);
		window.scroll({
			top: offsetTop,
			left: 0,
			behavior: 'smooth'
		});
	}
	render() {
		return (
			<div className="container mt-xl-5 pt-5 direction-rtl text-center quick-start-smart-phone-main-container" id="quick-start-conainer" ref={(qs) => this.quickStartInstance = qs }>
				<div className="row pb-5 step-by-step-tab-content-title">
					<div className="col-11">
						<h1 className="text-right">همین الان شروع کنید</h1>
					</div>
				</div>
				<div className="row mb-5">
					<div className="col-12 mt-3">
						<div className="row border-bottom-faq quick-start-smart-phone">
							<div className="col-10 text-right"><Link to="/step-by-step/setting/ثبت-نام/295">ثبت نام و ایجاد پروژه</Link></div>
							<div className="col-2 text-left quick-start-smart-phone-items-padding-left">
								<img className="next" src={next} alt="ثبت نام و ایجاد پروژه"/>
							</div>
						</div>
					</div>
					<div className="col-12 mt-3">
						<div className="row border-bottom-faq quick-start-smart-phone">
							<div className="col-10 text-right"><Link to="/step-by-step/payment-and-purchase/خرید-نقدی/211">خرید مصالح و پرداخت هزینه ها</Link></div>
							<div className="col-2 text-left quick-start-smart-phone-items-padding-left">
								<img className="next" src={next} alt="خرید مصالح و پرداخت هزینه ها"/>
							</div>
						</div>
					</div>
					<div className="col-12 mt-3">
						<div className="row border-bottom-faq quick-start-smart-phone">
							<div className="col-10 text-right"><Link to="/step-by-step/payment-and-purchase/پرداخت-حقوق-و-دستمزد/231">پرداخت حقوق و دستمزد</Link></div>
							<div className="col-2 text-left quick-start-smart-phone-items-padding-left">
								<img className="next" src={next} alt="پرداخت حقوق و دستمزد"/>
							</div>
						</div>
					</div>
					<div className="col-12 mt-3">
						<div className="row border-bottom-faq quick-start-smart-phone">
							<div className="col-10 text-right"><Link to="/step-by-step/functions/کارکرد-روزانه/2237">ثبت کارکرد کارکنان</Link></div>
							<div className="col-2 text-left quick-start-smart-phone-items-padding-left">
								<img className="next" src={next} alt="ثبت کارکرد کارکنان"/>
							</div>
						</div>
					</div>
					<div className="col-12 mt-3">
						<div className="row border-bottom-faq quick-start-smart-phone">
							<div className="col-10 text-right"><Link to="/step-by-step/payment-and-purchase/خرید-اعتباری/213">خرید اعتباری (نسیه)</Link></div>
							<div className="col-2 text-left quick-start-smart-phone-items-padding-left">
								<img className="next" src={next} alt="خرید اعتباری (نسیه)"/>
							</div>
						</div>
					</div>
					<div className="col-12 mt-3">
						<div className="row border-bottom-faq quick-start-smart-phone">
							<div className="col-10 text-right"><Link to="/step-by-step/payment-and-purchase/تسویه-بدهی-و-پیش-پرداخت/233">تسویه بدهی</Link></div>
							<div className="col-2 text-left quick-start-smart-phone-items-padding-left">
								<img className="next" src={next} alt="تسویه بدهی"/>
							</div>
						</div>
					</div>
					<div className="col-12 mt-3">
						<div className="row border-bottom-faq quick-start-smart-phone">
							<div className="col-10 text-right"><Link to="/step-by-step/reports/مشاهده/2239">گزارش حساب ها</Link></div>
							<div className="col-2 text-left quick-start-smart-phone-items-padding-left">
								<img className="next" src={next} alt="گزارش حساب ها"/>
							</div>
						</div>
					</div>
				</div>
			</div>

		);
	}
}

export default QuickStart;